import styled, { createGlobalStyle } from "styled-components";
import { Table, Card, Input, Button, TreeSelect } from "antd";

// Custom checkbox component
export const CustomCheckbox = styled.input.attrs({ type: "checkbox" })`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-radius: 3px;
  background-color: white;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0e49b5;
  }

  /* Checked state */
  &:checked {
    background-color: #0e49b5;
    border-color: #0e49b5;
  }

  /* Checkmark */
  &:checked::after {
    content: "";
    position: absolute;
    left: 3px;
    top: 0px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(14, 73, 181, 0.1);
  }
`;

// Global styles for fonts
export const UserManagementGlobalStyles = createGlobalStyle`
  /* Email dropdown styles */
  .email-dropdown .ant-select-item {
    padding: 8px 12px !important;
    border-radius: 8px !important;
    margin: 2px 4px !important;
    
    &:hover {
      background-color: #f5f8fc !important;
    }
    
    &.ant-select-item-option-selected {
      background-color: #e6f3ff !important;
    }
  }

  /* AutoComplete input styling */
  .custom-invite-modal .ant-select-auto-complete {
    border: none !important;
    box-shadow: none !important;
    
    .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
      padding: 0 !important;
    }
    
    .ant-select-selection-search-input {
      font-family: 'Inter', sans-serif !important;
      font-size: 12px !important;
      color: #6b7280 !important;
    }
  }

  /* Product dropdown option styles */
  .ant-select-dropdown .ant-select-item.product-option-item {
    border-radius: 9999px !important;
    margin: 3px 6px !important;
    padding: 8px 16px !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 14px !important;
    line-height: 20px !important;
    transition: all 0.2s ease !important;
    min-height: 36px !important;
    display: flex !important;
    align-items: center !important;
    
    &:hover {
      background-color: #f5f8fc !important;
      color: #0e49b5 !important;
      border-radius: 9999px !important;
    }
    
    &.ant-select-item-option-selected {
      background-color: #f5f8fc !important;
      color: #0e49b5 !important;
      font-weight: 500 !important;
    }
    
    &.ant-select-item-option-active {
      background-color: #f5f8fc !important;
      color: #0e49b5 !important;
    }
  }
`;

// Main container
export const UserManagementContainer = styled.div`
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-inline: var(--page-inset-x, 1.5rem);
  padding-block: var(--page-inset-top, 2.25rem) 2.25rem;
  width: 100%;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  .ant-card {
    width: 100%;
    margin: 0;
  }

  .ant-btn,
  .ant-input,
  .ant-select,
  button {
    font-family: "Inter", sans-serif;
  }

  .ant-select-selector {
    border-radius: 9999px !important;
  }

  .ant-select-dropdown {
    border-radius: 12px !important;
  }

  /* Custom styling for select with tag display */
  .ant-select-selection-item {
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    height: 100% !important;

    .ant-tag {
      margin: 0 !important;
      border-radius: 60rem !important;
    }
  }

  .ant-select-selector {
    display: flex !important;
    align-items: center !important;
    min-height: 32px !important;
  }

  /* Custom font size for market select dropdown */
  .market-select-custom-font {
    .ant-select-selector {
      font-size: 0.75rem !important;
      font-family: "Inter", sans-serif !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
      border: 1px solid rgba(0, 0, 0, 0.15) !important;
    }

    .ant-select-selection-item {
      font-size: 0.75rem !important;
      font-family: "Inter", sans-serif !important;
      line-height: normal !important;
      display: flex !important;
      align-items: center !important;
    }

    .ant-select-selection-placeholder {
      font-size: 0.75rem !important;
      font-family: "Inter", sans-serif !important;
      color: rgba(0, 0, 0, 0.45) !important;
    }

    .ant-select-arrow {
      color: rgba(0, 0, 0, 0.45) !important;
    }

    &:hover .ant-select-selector {
      border-color: #0e49b5 !important;
    }

    &.ant-select-focused .ant-select-selector {
      border-color: #0e49b5 !important;
      box-shadow: 0 0 0 2px rgba(14, 73, 181, 0.1) !important;
    }
  }

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 16px;
  }
`;

// Title with Satoshi font
export const PageTitle = styled.div`
  height: 4rem;
  font-family: "Satoshi";
  font-weight: 700;
  font-size: 2.5rem;
  color: #000000d9;
`;

// Styled search input
export const StyledSearchInput = styled(Input)`
  width: 100%;
  height: 3.25rem;
  border-radius: 9999px;

  .ant-input {
    border-radius: 9999px;
    height: 100%;
  }

  .ant-input-affix-wrapper {
    border-radius: 9999px;
    height: 100%;
    padding: 0 1rem;
  }
  .ant-input::placeholder {
    color: #00000040;
    font-size: 0.875rem;
    font-weight: 400;
  }
`;

// Styled table
export const UserManagementTable = styled(Table)`
  font-family: "Inter", sans-serif;
  width: 100%;
  border-radius: 1.5rem;

  .ant-table {
    width: 100%;
  }

  .ant-table-container {
    width: 100%;
    overflow-x: auto;
    border: 0.5px solid rgba(0, 0, 0, 0.06);
    border-radius: 1.5rem 1.5rem 0 0;
    border-bottom: none;
  }

  .ant-table-thead > tr > th {
    background-color: #fafafa;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
    border-right: 0.5px solid rgba(0, 0, 0, 0.06);
    border-left: 0.5px solid rgba(0, 0, 0, 0.06);
    border-top: 0.5px solid rgba(0, 0, 0, 0.06);
    font-size: 0.875rem;
    color: #27272a;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    padding: 0.625rem;
  }

  .ant-table-tbody {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);

    td {
      border: 0.5px solid rgba(0, 0, 0, 0.06) !important;
      border-collapse: collapse;
      padding-block: 10px !important;
      padding-inline: 10px !important;
      /* Cells spanning multiple product/market rows (Name, Role, the
         selection checkbox) must anchor to the top row of their span
         instead of the browser default of centering across the whole
         merged block. */
      vertical-align: top !important;
    }

    tr:first-child td {
      border-top: none !important;
    }
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #f8fafc;
  }

  /* Empty-state ("No users found" / "No active users" / "No deactivated
     users") stays a muted grey — the body-cell color above would otherwise
     darken the placeholder row. One shared grey across the page's empty
     states. */
  .ant-table-tbody > tr.ant-table-placeholder > td {
    color: #a1a1aa !important;
  }
  .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background: transparent;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: transparent !important;
  }

  .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background: #f8fafc !important;
  }

  .ant-table-selection-column {
    width: 48px;
  }

  /* Selection column styling */
  .ant-table-thead > tr:first-child th.ant-table-selection-column {
    background-color: #fafafa !important;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06) !important;
    border-right: 0.5px solid rgba(0, 0, 0, 0.06) !important;
    border-left: 0.5px solid rgba(0, 0, 0, 0.06) !important;
    border-top: 0.5px solid rgba(0, 0, 0, 0.06) !important;
  }
`;

// Action buttons
export const ActionButton = styled(Button)`
  &.text-blue-600:hover {
    background-color: #dbeafe !important;
  }

  &.text-red-600:hover {
    background-color: #fee2e2 !important;
  }
`;

// Modal styles
export const ModalStyles = createGlobalStyle`
  .ant-modal-content .ant-form-item-label > label {
    font-weight: 500;
    color: #374151;
    font-family: 'Inter', sans-serif;
  }

  /* Custom Invite Modal Styles */
  .custom-invite-modal .ant-modal-content {
    padding: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    max-width: none !important;
  }

  .custom-invite-modal .ant-modal-header {
    display: none !important;
  }

  .custom-invite-modal .ant-modal-body {
    padding: 0 !important;
  }

  .custom-invite-modal .ant-modal-footer {
    display: none !important;
  }

  .custom-invite-modal .ant-modal-close {
    display: none !important;
  }

  /* Custom form styles for invite modal */
  .custom-invite-modal .ant-form-item {
    margin-bottom: 0 !important;
  }

  .custom-invite-modal .ant-form-item-explain-error {
    margin-top: 4px;
    font-size: 12px;
    color: #ef4444;
    font-family: 'Inter', sans-serif;
  }

  .custom-invite-modal .ant-input {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    line-height: 16px;
  }

  .custom-invite-modal .ant-input:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .custom-invite-modal .ant-select-multiple .ant-select-selection-item {
    background: #f1f5f9;
    border: 0.5px solid rgba(0,0,0,0.05);
    border-radius: 999px;
    padding: 2px 8px;
    margin: 1px;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #0e49b5;
  }

  /* Custom radio button styles */
  .custom-invite-modal input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    border: 1px solid rgba(0,0,0,0.25);
    border-radius: 50%;
    margin: 0;
    padding: 0;
    position: relative;
    cursor: pointer;
    outline: none;
    background: white;
  }

  .custom-invite-modal input[type="radio"]:checked {
    border: 1px solid #0e49b5;
    background: white;
  }

  .custom-invite-modal input[type="radio"]:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6px;
    height: 6px;
    background: #0e49b5;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  /* Custom email tag styles */
  .custom-invite-modal .email-tag {
    background: #f1f5f9;
    border: 0.5px solid rgba(0,0,0,0.05);
    border-radius: 999px;
    padding: 4px 12px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-right: 8px;
  }

  .custom-invite-modal .email-tag span {
    color: #2563eb;
    font-size: 12px;
    font-family: 'Inter', sans-serif;
  }

  .custom-invite-modal .email-tag button:hover {
    background: rgba(0,0,0,0.05);
    border-radius: 50%;
  }

  /* Ensure confirm modals are visible */
  .ant-modal-confirm {
    z-index: 1050 !important;
  }

  .ant-modal-confirm .ant-modal-content {
    border-radius: 12px;
    font-family: 'Inter', sans-serif;
  }

  .ant-modal-confirm .ant-modal-header {
    border-radius: 12px 12px 0 0;
  }

  .ant-modal-confirm .ant-modal-body {
    padding: 24px;
    font-family: 'Inter', sans-serif;
  }

  .ant-modal-confirm-title {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 18px;
  }

  .ant-modal-confirm-content {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    margin-top: 8px;
  }
`;

// Market View Components
export const MarketViewContainer = styled.div`
  font-family: "Inter", sans-serif;
  width: 100%;
`;

export const MarketCollapseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: #ffffff;
  border: 0.5px solid rgba(0, 0, 0, 0.06);
  border-radius: ${(props) =>
    props.isExpanded ? "1.5rem 1.5rem 0 0" : "1.5rem"};
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: ${(props) => (props.isExpanded ? "0" : "1rem")};

  &:hover {
    background-color: #f8fafc;
  }

  .market-title {
    font-family: "Satoshi", sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    color: #000000d9;
  }

  .user-count {
    font-family: "Inter", sans-serif;
    font-size: 0.875rem;
    color: #6b7280;
    margin-left: 0.5rem;
  }

  .expand-icon {
    transition: transform 0.2s ease;
    transform: ${(props) =>
      props.isExpanded ? "rotate(180deg)" : "rotate(0deg)"};
    color: #6b7280;
  }
`;

export const MarketCollapseContent = styled.div`
  border: 0.5px solid rgba(0, 0, 0, 0.06);
  border-top: none;
  border-radius: 0 0 1.5rem 1.5rem;
  background-color: #ffffff;
  margin-bottom: 1rem;
  overflow: hidden;
`;

export const MarketTable = styled(Table)`
  font-family: "Inter", sans-serif;
  width: 100%;

  .ant-table {
    width: 100%;
  }

  .ant-table-container {
    width: 100%;
    overflow-x: auto;
    border: none;
    border-radius: 0;
  }

  .ant-table-thead > tr > th {
    background-color: #fafafa;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
    border-right: 0.5px solid rgba(0, 0, 0, 0.06);
    border-left: 0.5px solid rgba(0, 0, 0, 0.06);
    border-top: none;
    font-size: 0.875rem;
    color: #27272a;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    padding: 0.625rem;
  }

  .ant-table-thead > tr:first-child th:first-child {
    border-left: none;
  }

  .ant-table-thead > tr:first-child th:last-child {
    border-right: none;
  }

  .ant-table-tbody {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);

    td {
      border: 0.5px solid rgba(0, 0, 0, 0.06) !important;
      border-collapse: collapse;
      padding-block: 10px !important;
      padding-inline: 10px !important;
      /* Cells spanning multiple product/market rows (Name, Role, the
         selection checkbox) must anchor to the top row of their span
         instead of the browser default of centering across the whole
         merged block. */
      vertical-align: top !important;
    }

    tr td:first-child {
      border-left: none !important;
    }

    tr td:last-child {
      border-right: none !important;
    }

    tr:last-child td {
      border-bottom: none !important;
    }
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #f8fafc;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: transparent !important;
  }

  .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background: #f8fafc !important;
  }

  .ant-table-selection-column {
    width: 48px;
  }

  /* Selection column styling */
  .ant-table-thead > tr:first-child th.ant-table-selection-column {
    background-color: #fafafa !important;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06) !important;
    border-right: 0.5px solid rgba(0, 0, 0, 0.06) !important;
    border-left: none !important;
    border-top: none !important;
  }
`;

export const MarketPaginationWrapper = styled.div`
  padding: 0 1.5rem 1rem;
`;

export const ExpandAllControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;

  .expand-control-btn {
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    color: #000000c0;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    &:hover {
      color: #0c3d96;
    }
  }
`;

// Custom TreeSelect for InviteUserModal
export const InviteModalTreeSelector = styled(TreeSelect)`
  /* Custom styling for InviteUserModal TreeSelect based on FilterTreeSelector pattern */
  height: 2.5rem;
  display: flex;
  align-items: center;

  & .ant-select-selector {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 0.75rem;
    padding-block: 0;
    border: 1px solid #00000028 !important;
    border-radius: 1rem !important;
    background-color: #ffffff;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: #0e49b5 !important;
    }

    &:focus-within {
      border-color: #0e49b5 !important;
      box-shadow: 0 0 0 2px rgba(14, 73, 181, 0.1);
    }
  }

  & .ant-select-selection-item {
    display: flex;
    align-items: center;

    /* Reset line-height so it does not interfere with the flex layout */
    line-height: normal;
    margin-block: 6px;

    /* Custom tag styling for InviteUserModal */
    background-color: #f7f9fc;
    border: 1px solid #00000010;
    border-radius: 9999px;
    color: #0e49b5;
    font-size: 0.75rem;
    height: 1.5rem;
    padding: 0 0.5rem;
    margin-right: 0.25rem;
  }

  & .ant-select-multiple .ant-select-selection-overflow-item-suffix {
    margin-block: 0;
  }

  & .ant-select-selection-overflow {
    height: calc(2.5rem - 2px);
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
  }

  & .ant-select-selection-wrap {
    display: block;
    height: 100%;
  }

  & .ant-select-selection-search {
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  & .ant-select-selection-search-input {
    height: calc(2.5rem - 2px) !important;
    color: #3f3f46;
    font-size: 0.875rem;
  }

  & .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.875rem;
    line-height: calc(2.5rem - 2px);
  }

  /* Label text and remove button inside a tag */
  & .ant-select-selection-item-content {
    padding-right: 4px;
    color: #0e49b5;
  }

  & .ant-select-selection-item-remove {
    color: #0e49b5;
    opacity: 0.7;

    &:hover {
      opacity: 1;
      color: #0c3d96;
    }
  }

  /* Suffix icon styling */
  & .ant-select-arrow {
    color: rgba(0, 0, 0, 0.45);
    transition: transform 0.2s ease;

    &.ant-select-arrow-loading {
      color: #0e49b5;
    }
  }

  &.ant-select-open .ant-select-arrow {
    transform: rotate(180deg);
  }

  /* Clear icon styling */
  & .ant-select-clear {
    background-color: rgba(0, 0, 0, 0.06);
    color: rgba(0, 0, 0, 0.45);

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;
